export const trimHtml = (str) => str.replace(/<[^>]*>/g, '');
